import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import VaMessageList from './VaMessageList.vue'

export default withConfigTransport(VaMessageList)
